<div class="deactive-page">
  <div class="deactive-card">
    <div class="icon-circle" aria-hidden="true">
      <i class="bx bx-lock-alt"></i>
    </div>

    <h1 class="title">Restaurant {{ status | titlecase }}</h1>
    @if (status != 'not found') {
      <p class="description">This restaurant is currently {{ status }} by Fork &amp; Find.</p>
    }
    <p class="description">
      Restaurant status should be <b class="text-emphasis">published or activated</b> to use the
      dashboard. For any assistance or inquiries, please reach out using the details below.
    </p>

    <div class="contact">
      <p class="contact-item">
        <i class="bx bx-envelope"></i>
        <a href="mailto:support@superadmin.com">support&#64;superadmin.com</a>
      </p>
      <p class="contact-item">
        <i class="bx bx-phone"></i>
        <a href="tel:+14083518229">(408) 351-8229</a>
      </p>
    </div>

    <button type="button" class="signout-button" (click)="signOut()">
      <i class="bx bx-log-out"></i>
      Sign out
    </button>
  </div>
</div>
